import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import AttentionIcon from '../../asset/icons/icon_warning.svg';

const DialogAttention = ({
  handleClick,
  isOpen,
  subject = '',
  station_name = '',
  closeConfirmDialog,
}: {
  handleClick: () => void;
  isOpen: boolean;
  subject?: string;
  station_name?: string;
  closeConfirmDialog: () => void;
}) => {
  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={isOpen}
      className='flex items-center justify-center'
      aria-labelledby='attention-dialog'>
      <DialogContent className='text-center mx-3' id='attention-dialog'>
        <Box className='flex items-center justify-center flex-row gap-3'>
          <img src={AttentionIcon} alt='Attention' className='w-30' />
          <Typography className='font-bold text-20 my-5'>ATTENTION</Typography>
        </Box>
        <Typography>
          {subject ||
            'You are about to perform a Hard Rest on the following Station'}
        </Typography>
        {station_name && (
          <Typography className='text-18 text-white my-2'>
            {station_name}
          </Typography>
        )}

        <DialogActions className='p-0 mt-5 justify-center'>
          <Button variant='outlined' color='info' onClick={closeConfirmDialog}>
            Cancel
          </Button>
          <Button color='error' variant='contained' onClick={handleClick}>
            Ok
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAttention;
